var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSingleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.037 2.698a.83.83 0 00-1.077 0L5.727 6.566c-.486.43-.137 1.182.53 1.182H8.99v8.36c0 .766.682 1.392 1.517 1.392.834 0 1.517-.626 1.517-1.391v-8.36h2.716c.683 0 1.017-.752.531-1.183l-4.233-3.868z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleArrow);
export default __webpack_public_path__ + "static/media/single-arrow.fd723b02.svg";
export { ForwardRef as ReactComponent };